module.exports = __webpack_public_path__ + "static/img/icon_jinhua_a@2x.42bfe3d1.png";